export default __webpack_public_path__ + "static/media/Pre_psychology.10f52b65.svg";